/* =========================================================
   Leanne's Cookies — Shopify PDP configurator
   - Doosgrootte = productvariant (prijs volgt de variant)
   - Smaken + kaartje = line item properties (zichtbaar op de orderbon)
   - Validatie: som van de smaken moet exact gelijk zijn aan de doosgrootte
   ========================================================= */
(function () {
  "use strict";

  function initRoot(root) {
    var $ = function (s) { return root.querySelector(s); };
    var $all = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var form = $("[data-leanne-form]");
    var variantInput = $("[data-variant-input]");
    var priceEl = $("[data-price]");
    var pricePerEl = $("[data-price-per]");
    var locale = root.dataset.locale || "nl-NL";
    var currency = root.dataset.currency || "EUR";

    var money = function (cents) {
      try {
        return new Intl.NumberFormat(locale, { style: "currency", currency: currency }).format(cents / 100);
      } catch (e) { return "€" + (cents / 100).toFixed(2).replace(".", ","); }
    };

    var boxes = $all("[data-box]");
    var flavorEls = $all("[data-flavor]");
    var state = { size: 4, priceCents: 0, counts: {}, cardOn: false };

    flavorEls.forEach(function (el) { state.counts[el.dataset.flavor] = 0; });

    function total() {
      return Object.keys(state.counts).reduce(function (s, k) { return s + state.counts[k]; }, 0);
    }
    function flavorName(id) {
      var el = root.querySelector('[data-flavor="' + CSS.escape(id) + '"]');
      return el ? el.querySelector("[data-flavor-name]").textContent.trim() : id;
    }

    function render() {
      var sum = total(), size = state.size, remaining = size - sum, full = sum === size && size > 0;

      boxes.forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.variantId === variantInput.value)); });

      var mCount = $("[data-meter-count]"), mTotal = $("[data-meter-total]"),
          mFill = $("[data-meter-fill]"), mBadge = $("[data-meter-badge]"), meter = $("[data-meter]");
      if (mCount) mCount.textContent = sum;
      if (mTotal) mTotal.textContent = size;
      if (mFill) mFill.style.width = (size ? (sum / size) * 100 : 0) + "%";
      if (meter) meter.classList.toggle("is-full", full);
      if (mBadge) mBadge.textContent = full ? "Doos vol" : "Kies nog " + remaining;

      flavorEls.forEach(function (el) {
        var id = el.dataset.flavor, c = state.counts[id];
        el.querySelector("[data-val]").textContent = c;
        el.querySelector('[data-act="dec"]').disabled = c === 0;
        el.querySelector('[data-act="inc"]').disabled = full;
        el.classList.toggle("has-count", c > 0);
        // line item property: alleen versturen als > 0
        var prop = el.querySelector("[data-flavor-prop]");
        if (prop) { prop.value = c; prop.disabled = c === 0; }
      });

      if (priceEl) priceEl.textContent = money(state.priceCents);
      if (pricePerEl && size) pricePerEl.textContent = money(state.priceCents / size) + " per koekje";

      var list = $("[data-summary]");
      if (list) {
        var chosen = flavorEls.filter(function (el) { return state.counts[el.dataset.flavor] > 0; });
        if (!chosen.length) {
          list.innerHTML = '<li class="summary-empty">Nog geen smaken gekozen</li>';
        } else {
          list.innerHTML = chosen.map(function (el) {
            var id = el.dataset.flavor;
            return "<li><span>" + flavorName(id) + "</span><b>" + state.counts[id] + "×</b></li>";
          }).join("");
          if (state.cardOn) list.innerHTML += '<li style="color:var(--accent-deep)"><span>Persoonlijk kaartje</span><b>✓</b></li>';
        }
      }

      $all("[data-add]").forEach(function (btn) {
        btn.disabled = !full;
        var lbl = btn.querySelector("[data-add-label]");
        if (lbl) {
          if (full) lbl.textContent = "In winkelwagen · " + money(state.priceCents);
          else if (sum === 0) lbl.textContent = "Kies nog " + remaining + " koekjes";
          else lbl.textContent = "Nog " + remaining + " te kiezen";
        }
      });

      var sMeta = $("[data-sticky-meta]"), sSize = $("[data-sticky-size]"), sPrice = $("[data-sticky-price]");
      if (sMeta) sMeta.textContent = sum + " van " + size;
      if (sSize) sSize.textContent = size;
      if (sPrice) sPrice.textContent = money(state.priceCents);
    }

    function selectBox(b) {
      variantInput.value = b.dataset.variantId;
      state.size = parseInt(b.dataset.count, 10) || 4;
      state.priceCents = parseInt(b.dataset.priceCents, 10) || 0;
      // smaakverdeling resetten zodat de som altijd exact klopt
      Object.keys(state.counts).forEach(function (k) { state.counts[k] = 0; });
      render();
    }

    boxes.forEach(function (b) {
      b.addEventListener("click", function () {
        if (b.dataset.variantId === variantInput.value) return;
        selectBox(b);
      });
    });

    flavorEls.forEach(function (el) {
      var id = el.dataset.flavor;
      el.querySelector('[data-act="inc"]').addEventListener("click", function () {
        if (total() < state.size) { state.counts[id]++; render(); }
      });
      el.querySelector('[data-act="dec"]').addEventListener("click", function () {
        if (state.counts[id] > 0) { state.counts[id]--; render(); }
      });
    });

    var cardToggle = $("[data-card-toggle]"), cardField = $("[data-card-field]"),
        cardText = $("[data-card-text]"), cardProp = $("[data-card-prop]"), cardCount = $("[data-card-count]");
    if (cardToggle) {
      cardToggle.addEventListener("click", function () {
        state.cardOn = !state.cardOn;
        cardToggle.classList.toggle("is-on", state.cardOn);
        cardToggle.setAttribute("aria-pressed", String(state.cardOn));
        cardField.classList.toggle("is-open", state.cardOn);
        if (cardProp) cardProp.disabled = !(state.cardOn && cardText.value.trim());
        if (state.cardOn) setTimeout(function () { cardText.focus(); }, 60);
        render();
      });
      cardText.addEventListener("input", function () {
        var len = cardText.value.length;
        if (cardCount) { cardCount.textContent = len + " / 200"; cardCount.classList.toggle("over", len >= 200); }
        if (cardProp) { cardProp.value = cardText.value; cardProp.disabled = !(state.cardOn && cardText.value.trim()); }
      });
    }

    // Configurator leegmaken zodat de bezoeker meteen een nieuwe doos kan samenstellen
    function resetBuilder() {
      Object.keys(state.counts).forEach(function (k) { state.counts[k] = 0; });
      if (state.cardOn) {
        state.cardOn = false;
        if (cardToggle) { cardToggle.classList.remove("is-on"); cardToggle.setAttribute("aria-pressed", "false"); }
        if (cardField) cardField.classList.remove("is-open");
        if (cardText) cardText.value = "";
        if (cardProp) { cardProp.value = ""; cardProp.disabled = true; }
        if (cardCount) { cardCount.textContent = "0 / 200"; cardCount.classList.remove("over"); }
      }
      render();
    }

    // ---- Winkelwagen-lade ----
    function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
    var drawer = $("[data-cart-drawer]");
    var overlay = $("[data-cart-overlay]");
    var cartItemsEl = $("[data-cart-items]");

    function openCart() {
      fetchCart();
      if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add("is-visible"); }); }
      if (drawer) { drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); }
      document.body.style.overflow = "hidden";
    }
    function closeCart() {
      if (overlay) overlay.classList.remove("is-visible");
      if (drawer) { drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true"); }
      document.body.style.overflow = "";
      setTimeout(function () { if (overlay && drawer && !drawer.classList.contains("is-open")) overlay.hidden = true; }, 320);
    }
    function fetchCart() {
      if (!window.fetch) return;
      fetch("/cart.js", { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
    }
    function renderCart(cart) {
      if (!drawer) return;
      var n = cart.item_count || 0;
      drawer.classList.toggle("is-empty", n === 0);
      var hc = $("[data-cart-head-count]"); if (hc) hc.textContent = n ? "(" + n + ")" : "";
      if (n === 0) return;
      if (cartItemsEl) {
        cartItemsEl.innerHTML = cart.items.map(function (it) {
          var props = it.properties || {};
          var flav = Object.keys(props).filter(function (k) {
            return k.charAt(0) !== "_" && k !== "Persoonlijk kaartje" && props[k] && props[k] !== "0";
          }).map(function (k) { return props[k] + "\u00d7 " + k; }).join(", ");
          var cardVal = props["Persoonlijk kaartje"];
          var card = cardVal ? '<div class="cart-item__card">\u270e Kaartje: \u201c' + escapeHtml(cardVal) + '\u201d</div>' : "";
          var img = it.image ? '<img class="cart-item__thumb" src="' + it.image + '" alt="">' : '<div class="cart-item__thumb"></div>';
          var sub = (it.variant_title && it.variant_title !== "Default Title")
            ? escapeHtml(it.variant_title) + (flav ? " \u00b7 " + flav : "")
            : flav;
          return '<div class="cart-item">' + img +
            '<div class="cart-item__info"><div class="cart-item__name">' + escapeHtml(it.product_title || it.title) + '</div>' +
            (sub ? '<div class="cart-item__flav">' + sub + '</div>' : "") + card + '</div>' +
            '<div class="cart-item__right">' +
              '<button type="button" class="cart-item__remove" data-cart-remove="' + it.key + '" aria-label="Verwijder deze doos"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6 6 18" stroke-linecap="round"/></svg></button>' +
              '<span class="cart-item__price">' + money(it.final_line_price) + '</span>' +
            '</div></div>';
        }).join("");
      }
      var subEl = $("[data-cart-subtotal]"); if (subEl) subEl.textContent = money(cart.total_price);
      var ship = $("[data-cart-ship]");
      var msg = $("[data-cart-ship-msg]");
      if (root.dataset.freeShipAlways === "true") {
        if (ship) ship.classList.add("is-reached");           // verbergt de balk
        if (msg) msg.textContent = root.dataset.freeShipLabel || "Gratis verzending";
      } else {
        var threshold = parseInt(root.dataset.freeShipCents, 10) || 3500;
        var reached = threshold > 0 && cart.total_price >= threshold;
        if (ship) ship.classList.toggle("is-reached", reached);
        var pct = Math.min(100, threshold ? (cart.total_price / threshold) * 100 : 100);
        var fill = $("[data-cart-ship-fill]"); if (fill) fill.style.width = pct + "%";
        if (msg) msg.textContent = reached
          ? "Je hebt gratis verzending!"
          : "Nog " + money(threshold - cart.total_price) + " voor gratis verzending";
      }
    }

    var cartClose = $("[data-cart-close]"); if (cartClose) cartClose.addEventListener("click", closeCart);
    if (overlay) overlay.addEventListener("click", closeCart);
    $all("[data-cart-continue]").forEach(function (b) {
      b.addEventListener("click", function () {
        closeCart();
        var k = root.querySelector("[data-buy]"); if (k) k.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
    if (cartItemsEl) cartItemsEl.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-cart-remove]");
      if (!btn || !window.fetch) return;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ id: btn.dataset.cartRemove, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        renderCart(cart);
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }).catch(function () {});
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) closeCart(); });
    // Optioneel: koppel je thema-winkelwagenicoon met data-leanne-cart-open om deze lade te openen
    $all("[data-leanne-cart-open]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); openCart(); }); });

    // Toast
    var toast = $("[data-toast]"), toastTimer = null;
    function showToast(msg) {
      if (!toast) return;
      toast.querySelector("[data-toast-msg]").textContent = msg;
      toast.classList.add("is-visible");
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove("is-visible"); }, 3500);
    }

    // Add to cart (AJAX; opent de lade i.p.v. door te schieten naar /cart)
    function submitForm(e) {
      if (e) e.preventDefault();              // ALTIJD de normale navigatie naar /cart blokkeren
      if (total() !== state.size) {
        var k = root.querySelector("[data-buy]"); if (k) k.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (!form) return;
      if (!window.fetch) { form.submit(); return; } // alleen heel oude browsers
      var data = new FormData(form);
      fetch(root.dataset.cartAddUrl || "/cart/add.js", {
        method: "POST", body: data, headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" }
      }).then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      }).then(function (res) {
        if (!res.ok) { showToast((res.body && res.body.description) || "Toevoegen mislukt, probeer het opnieuw."); return; }
        // Doos toegevoegd → configurator leegmaken + lade openen. Renderfouten mogen NOOIT wegnavigeren.
        try {
          resetBuilder();
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.documentElement.dispatchEvent(new CustomEvent("cart:build"));
        } catch (err) {}
        if (root.dataset.redirectToCart === "true") { window.location.href = root.dataset.cartUrl || "/cart"; return; }
        openCart(); // eigen lade met inhoud + Afrekenen-knop
      }).catch(function () {
        // Alleen bij een echte netwerkfout: melding tonen, NIET wegnavigeren
        showToast("Geen verbinding — probeer het opnieuw.");
      });
    }
    if (form) form.addEventListener("submit", submitForm);
    var stickyAdd = $("[data-sticky-add]");
    if (stickyAdd && form) stickyAdd.addEventListener("click", function (e) { e.preventDefault(); submitForm(e); });

    // Sticky bar zichtbaar zodra de koopknop uit beeld is
    var stickyBar = $("[data-sticky-bar]"), anchor = $("[data-add]");
    if (stickyBar && anchor && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && window.scrollY > 400;
          stickyBar.classList.toggle("is-visible", show);
          stickyBar.setAttribute("aria-hidden", String(!show));
        });
      }, { rootMargin: "-80px 0px 0px 0px" }).observe(anchor);
    }

    // init op de standaard geselecteerde variant
    var initial = boxes.filter(function (b) { return b.dataset.variantId === variantInput.value; })[0] || boxes[0];
    if (initial) selectBox(initial); else render();
  }

  function init() { Array.prototype.slice.call(document.querySelectorAll("[data-leanne-pdp]")).forEach(initRoot); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();